import React from 'react';
import {Check} from 'lucide-react';

export type CheckoutStep = 'details' | 'delivery' | 'payment';

const STEPS: {key: CheckoutStep; label: string}[] = [
    {key: 'details', label: 'Details'},
    {key: 'delivery', label: 'Delivery'},
    {key: 'payment', label: 'Payment'},
];

interface CheckoutStepperProps {
    current: CheckoutStep;
}

const CheckoutStepper: React.FC<CheckoutStepperProps> = ({current}) => {
    const currentIndex = STEPS.findIndex((s) => s.key === current);

    return (
        <div className="flex items-center justify-center gap-0 mb-8">
            {STEPS.map((step, i) => {
                const isCompleted = i < currentIndex;
                const isActive = i === currentIndex;

                return (
                    <React.Fragment key={step.key}>
                        {i > 0 && (
                            <div className={`w-12 h-0.5 ${i <= currentIndex ? 'bg-mld-success' : 'bg-mld-panel-border'}`} />
                        )}
                        <div className="flex items-center gap-2">
                            <div
                                className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold ${
                                    isCompleted
                                        ? 'bg-mld-success text-white'
                                        : isActive
                                          ? 'bg-mld-primary text-white'
                                          : 'bg-mld-muted-text text-white'
                                }`}>
                                {isCompleted ? <Check className="h-4 w-4" /> : i + 1}
                            </div>
                            <span
                                className={`text-sm font-medium ${
                                    isActive ? 'text-mld-text-primary' : isCompleted ? 'text-mld-success' : 'text-mld-muted-text'
                                }`}>
                                {step.label}
                            </span>
                        </div>
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default CheckoutStepper;
